import { Icon } from 'idea-react';
import { observer } from 'mobx-react';
import { Component, createRef } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-class-tools';

import { mainNavLinks, MenuItem } from '../meta';
import * as style from './LeftSidebar.module.less';

@withRouter
@observer
export class LeftSidebar extends Component<RouteComponentProps> {
    #root = createRef<HTMLElement>();

    scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    componentDidMount() {
        this.#root.current?.addEventListener('click', this.scrollToTop);
    }

    componentWillUnmount() {
        this.#root.current?.removeEventListener('click', this.scrollToTop);
    }

    renderItem = ({ title, icon, href, subs }: MenuItem, depth = 0) => {
        const hash = '#' + this.props.location.pathname;
        const active = hash === href || (href === '#/' && hash === '');
        const className = `${style.navLink} ${active ? style.active : ''}`,
            marginLeft = depth * 1 + 'rem';
        const text = (
            <>
                {icon && <Icon name={icon} />}
                {title}
            </>
        );

        return (
            <li key={title} className="p-1">
                {href ? (
                    <a className={className} style={{ marginLeft }} href={href}>
                        {text}
                    </a>
                ) : (
                    <details open>
                        <summary className={className} style={{ marginLeft }}>
                            {text} <Icon name="chevron-down" />
                        </summary>
                        {this.renderMenu(subs!, depth + 1)}
                    </details>
                )}
            </li>
        );
    };

    renderMenu = (items: MenuItem[], depth = 0) => (
        <ul className="list-unstyled">
            {items.map(item => this.renderItem(item, depth))}
        </ul>
    );

    render() {
        return (
            <nav ref={this.#root} className={style.sidebar}>
                {this.renderMenu(mainNavLinks())}
            </nav>
        );
    }
}
